import { Stack } from "@mui/material";
import { ListingDetailsHeader } from "./listingDetailsHeader/ListingDetailsHeader";
import { ListingDetailsModalSection } from "./ListingDetailsModalSection";
import { ListingDetailsContent } from "./listingDetailsContent";

export const ListingDetailsSection = () => {
  return (
    <Stack className="flex flex-col space-y-[24px] lg:space-y-[50px]">
      <ListingDetailsHeader />
      <ListingDetailsContent />
      <ListingDetailsModalSection />
    </Stack>
  );
};
